module.exports = __webpack_public_path__ + "static/media/unlock.b3067d54.svg";